module.exports = __webpack_public_path__ + "static/img/IMG_20170525_150531.c0ffd296.jpg";